import styled from "styled-components";

export const PopupModalContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--bs-modal-overlay-bg);
    z-index: 1000;
    direction: ltr;
    overflow-y: scroll;
    &::-webkit-scrollbar-track {
        border: 1px solid #000;
        padding: 5px;
        background-color: transparent;
    }

    &::-webkit-scrollbar {
        width: 7px;
        
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0,0,0,.3);
        background-color: rgba(255,255,255,0.2);
        border: 1px solid #000;
    }
    &.fa-IR{
        direction: rtl;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        background-color: #000;
    }
`
export const PopupContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--bs-modal-overlay-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    direction: ltr;
    &.fa-IR{
        direction: rtl;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        background-color: #000;
    }
`
export const ConfirmModalWrapper = styled.div`
    background: #fff;
    border-radius: 20px;
    color: #000;
    padding: .5em;
    width: 100%;
    max-width: 500px;
`
export const PopupModal = styled.div`
    min-width: 300px;
    padding: .5em;
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    &.confirm{
        margin-top: 2em;
        border-radius: 15px;
        box-shadow: 0 0 .5em .2rem var(--bs-modal-shadow);
        min-height: fit-content;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        min-height: calc(100vh - (48px + 1em));
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        border-radius: 0;
    }
    
`
export const PopupBody = styled.div`
    padding: 1em;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0;
    }
`
export const PopupMainContent = styled.div`
    width: 100%;
    padding: 1em;
    max-width: ${({ $maxWidth }) => $maxWidth??`600px`};
    border-radius: 20px;
    background: #fff;
    color: #333;
    box-shadow: 1px 0px 5px rgba(255, 255, 255, 0.5);
`
export const CloseButton = styled.button`
    color: #111;
    background: #fff;
    border: none;
    border-radius: 50%;
    font-size: 26px;
    width: 40px;
    height: 40px;
    position: absolute;
    display: flex;
    justify-content: center;
    z-index: 999;
    align-items: center;
    top: 1em;
    right: 1em;
    cursor: pointer;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        background: var(--primary-color);
        color: #fff;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        position: relative;
        top: 0;
        right: 0;
        margin: .5em;
    }
`
export const BackButton = styled.button`
    color: var(--text-color);
    background: transparent;
    border: none;
    font-size: 32px;
    position: absolute;
    top: 1em;
    left: 1em;
    cursor: pointer;
    transition: all ease-in-out .3s;
    &:hover{
        transition: all ease-in-out .3s;
        color: var(--primary-color);
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        position: relative;
        top: 0;
        left: 0;
        margin: .5em;
    }
`
export const ConfirmBody = styled.div`
    min-width: 400px;
    max-width: 400px;
    padding: .5em;
`
export const PopupFooter = styled.div`
    padding: 0.5em 1em 1em 1em;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: .5em;
    & button{
        min-width: 100px;
    }
`
export const ModalButton = styled.button`

`